module.exports = __webpack_public_path__ + "static/media/29ADMSPC10.76b93060.jpg";